import { AIScribeLinkedUser } from "../Api/AIScribeUser.dto";

class AIScribeLinkedUserModel {
    private readonly email: string;
    private readonly subscriptionStatus: AIScribeUserSubscriptionStatus;

    private constructor(fields: { email: string; subscriptionStatus: AIScribeUserSubscriptionStatus }) {
        Object.assign(this, fields);
    }

    public getEmail(): string {
        return this.email;
    }

    public hasSubscription(): boolean {
        return this.subscriptionStatus === AIScribeUserSubscriptionStatus.Active;
    }

    public static fromDto(dto: AIScribeLinkedUser): AIScribeLinkedUserModel {
        if (!dto)
            return null;

        return new AIScribeLinkedUserModel({
            subscriptionStatus: dto.SubscriptionStatus,
            email: dto.Email
        });
    }
}

enum AIScribeUserSubscriptionStatus {
    Active,
    Inactive
}

export { AIScribeLinkedUserModel };
